<template>
  <v-layout align-center justify-center>
    <v-flex xs12 lg10>
      <v-layout column justify-center class="mb-4">
        <h3 class="logo">id</h3>
        <span class="project">personal</span>
      </v-layout>
      <v-layout column>
        <v-flex xs12>
          <v-card flat :disabled="loading">
            <v-form @submit.prevent="login">
              <validation-observer ref="form">
                <validation-provider name="email" rules="required" v-slot="{ errors }">
                  <v-text-field
                    @keydown.enter="focusPassword"
                    v-model.trim="formData.username"
                    :error-messages="errors"
                    :label="$t('auth.email')"
                    :disabled="loading"
                    color="tertiary"
                    autocomplete
                    autofocus
                    outlined
                    clearable
                    class="mb-3"
                  />
                </validation-provider>
                <validation-provider name="password" rules="required" v-slot="{ errors }">
                  <v-text-field
                    v-model.trim="formData.password"
                    clearable
                    outlined
                    ref="password"
                    color="tertiary"
                    autocomplete="current-password"
                    :type="showPassword ? 'text' : 'password'"
                    :disabled="loading"
                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    :error-messages="errors"
                    :label="$t('auth.password')"
                    @keydown.enter="login"
                    @click:append="showPassword = !showPassword"
                  />
                </validation-provider>
              </validation-observer>
              <v-btn
                :loading="loading"
                :disabled="loading"
                color="primary"
                block
                large
                depressed
                class="mt-5"
                @click.native="loader = 'loading'"
                @click.stop="login"
              >
                {{ $t("auth.sign_in") }}
              </v-btn>
              <v-btn
                :loading="loading"
                outlined
                block
                large
                depressed
                class="mt-5"
                color="tertiary"
                @click="onLoginWithAmazonCognitoBtnClick"
              >
                <v-icon left>mdi-amazon</v-icon> {{ $t("auth.login_with_amazon") }}
              </v-btn>
              <!-- <v-btn outlined block large depressed class="mt-5" @click="onLoginWithGoogleBtnClick">
                <v-icon left>mdi-google</v-icon> {{ $t("auth.login_with_google") }}
              </v-btn> -->
            </v-form>
          </v-card>
        </v-flex>
        <v-flex xs12 class="mt-3">
          <v-btn block text :disabled="loading" depressed :to="{ name: 'forgot' }">
            {{ $t("auth.forget_password") }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from "vuex";
  import TravisAes from "./TravisAes";

  export default {
    name: "login",
    props: {
      redirect: String
    },
    data() {
      return {
        formData: {
          username: null,
          password: null
        },
        showPassword: false,
        loading: false
      };
    },
    computed: {
      ...mapGetters({
        // loading: "auth/loading"
      })
    },
    methods: {
      login() {
        this.$refs.form.validate().then(valid => {
          if (valid) {
            this.loading = true;
            let aes = new TravisAes();
            const authData = {
              username: this.formData.username,
              password: aes.encrypt(process.env.VUE_APP_PASSWORD_HASH, this.formData.password)
            };
            this.$store
              .dispatch("auth/LOGIN", authData)
              .then(({ firstTimePassword, passwordExpired }) => {
                this.$store
                  .dispatch("auth/FETCH_MOBILE_SETTINGS")
                  .then(() =>
                    this.$store
                      .dispatch("auth/FETCH_PENDING_FEEDBACKS")
                      .then(pendingFeedbacks => {
                        if (firstTimePassword || passwordExpired) {
                          this.$router.push({ name: "auth_change_password" });
                        } else if (pendingFeedbacks.length > 0) {
                          this.$router.push({ name: "pending_feedbacks" });
                        } else if (this.$route.params.redirect) {
                          this.$router.push(this.$route.params.redirect);
                        } else {
                          this.$router.push({ name: "dashboard" });
                        }
                      })
                      .catch(console.error)
                  )
                  .catch(console.error);
              })
              .catch(() => {
                this.$helpers.showNotification(this.$t("api_error.401"), "error", true);
                this.loading = false;
              });
          }
        });
      },
      async onLoginWithAmazonCognitoBtnClick() {
        const cognitoUrl =
          "https://idp.federate.amazon.com/api/oauth2/v1/authorize?response_type=token&client_id=PayrollTurkeyMyamazonIdenfit&scope=openid&redirect_uri=https://myamazon.idenfit.com/auth/login";

        const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

        const width = window.innerWidth
          ? window.innerWidth
          : document.documentElement.clientWidth
          ? document.documentElement.clientWidth
          : screen.width;
        const height = window.innerHeight
          ? window.innerHeight
          : document.documentElement.clientHeight
          ? document.documentElement.clientHeight
          : screen.height;
        const w = 600;
        const h = 600;

        const systemZoom = width / window.screen.availWidth;
        const left = (width - w) / 2 / systemZoom + dualScreenLeft;
        const top = (height - h) / 2 / systemZoom + dualScreenTop;
        const newWindow = window.open(
          cognitoUrl,
          "Login with Amazon",
          `
            scrollbars=yes,
            width=${w / systemZoom},
            height=${h / systemZoom},
            top=${top},
            left=${left}
            `
        );

        if (window.focus) newWindow.focus();
      },
      async onLoginWithGoogleBtnClick() {
        try {
          const googleUser = await this.$gAuth.signIn();
          if (!googleUser) {
            return null;
          }
          this.isGAuthInit = this.$gAuth.isAuthorized;
          this.loading = true;
          this.$store
            .dispatch("auth/LOGIN_WITH", {
              token: googleUser.getAuthResponse().id_token,
              url: "google"
            })
            .then(() => {
              this.$store
                .dispatch("auth/FETCH_MOBILE_SETTINGS")
                .then(() =>
                  this.$store
                    .dispatch("auth/FETCH_PENDING_FEEDBACKS")
                    .then(pendingFeedbacks => {
                      if (pendingFeedbacks.length > 0) {
                        this.$router.replace({ name: "pending_feedbacks" });
                      } else if (this.$route.params.redirect) {
                        this.$router.push(this.$route.params.redirect);
                      } else {
                        this.$router.replace({ name: "dashboard" });
                      }
                    })
                    .catch(console.error)
                )
                .catch(console.error);
            })
            .catch(() => {
              this.$helpers.showNotification(this.$t("api_error.401"), "error", true);
              this.loading = false;
            });
        } catch (error) {
          console.error(error);
          return null;
        }
      },
      focusPassword() {
        this.$nextTick(() => this.$refs.password.focus());
      },
      initAmazonOAuth() {
        window.onAmazonLoginReady = function() {
          amazon.Login.setClientId("amzn1.application-oa2-client.5c41bbae24324f56b0d4aa0ef86e545f");
        };
        (function(doc) {
          const script = doc.createElement("script");
          script.type = "text/javascript";
          script.async = true;
          script.id = "amazon-login-sdk";
          script.src = "https://assets.loginwithamazon.com/sdk/na/login1.js";
          doc.getElementById("amazon-root").appendChild(script);
        })(document);
      },
      initGoogleOAuth() {
        const checkGauthLoad = setInterval(() => {
          this.isGAuthInit = this.$gAuth.isInit;
          if (this.isGAuthInit) clearInterval(checkGauthLoad);
        }, 1000);
      },
      parseRouteHash() {
        const params = {};
        if (this.$route.hash) {
          this.$route.hash
            .slice(1)
            .split("&")
            .forEach(entry => {
              const splittedEntry = entry.split("=");
              if (splittedEntry.length === 2) {
                params[splittedEntry[0]] = splittedEntry[1];
              }
            });
        }
        return params;
      },
      onStorageChange() {
        const accessToken = localStorage.getItem("amazon_access_token");
        if (accessToken) {
          localStorage.removeItem("amazon_access_token");
          this.loading = true;
          this.$store
            .dispatch("auth/LOGIN_WITH", {
              token: accessToken,
              url: "amazon"
            })
            .then(() => {
              this.$store
                .dispatch("auth/FETCH_MOBILE_SETTINGS")
                .then(() =>
                  this.$store
                    .dispatch("auth/FETCH_PENDING_FEEDBACKS")
                    .then(pendingFeedbacks => {
                      if (pendingFeedbacks.length > 0) {
                        this.$router.replace({ name: "pending_feedbacks" });
                      } else if (localStorage.getItem("redirectPath")) {
                        this.$router.push(localStorage.getItem("redirectPath"));
                        localStorage.removeItem("redirectPath");
                      } else {
                        this.$router.replace({ name: "dashboard" });
                      }
                    })
                    .catch(console.error)
                )
                .catch(console.error);
            })
            .catch(() => {
              this.$helpers.showNotification(this.$t("api_error.401"), "error", true);
              this.loading = false;
            });
        }
      }
    },
    mounted() {
      window.addEventListener("storage", this.onStorageChange);
    },
    beforeDestroy() {
      window.removeEventListener("storage", this.onStorageChange);
    },
    created() {
      const params = this.parseRouteHash();
      if (params.access_token) {
        localStorage.setItem("amazon_access_token", params.access_token);
        window.close();
      } else if (this.$route.params.redirect) {
        localStorage.setItem("redirectPath", this.$route.params.redirect);
      }
    }
  };
</script>

<style scoped>
  .logo {
    font-family: "Paytone One", sans-serif;
    font-size: 100px;
    text-align: center;
    display: block;
    color: var(--v-primary-base);
  }

  .project {
    font-family: "Quicksand", sans-serif;
    font-size: 26px;
    color: var(--v-primary-base);
    text-align: center;
    margin-top: -30px;
  }
</style>
